import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DateDisplay, Row, Tag } from '@dossierhq/design';
import { useEffect, useReducer } from 'react';
import { useAdminLoadChangelog } from '../../hooks/useAdminLoadChangelog.js';
import { ChangelogStateActions, initializeChangelogState, reduceChangelogState, } from '../../reducers/ChangelogReducer/ChangelogReducer.js';
import { ChangelogConnectionButtons } from '../ChangelogConnectionButtons/ChangelogConnectionButtons.js';
export function EntityChangelogList({ entity }) {
    const [changelogState, dispatchChangelogState] = useReducer(reduceChangelogState, {}, initializeChangelogState);
    useAdminLoadChangelog(changelogState, dispatchChangelogState);
    const entityId = entity.id; // since the entity object is not stable
    useEffect(() => {
        dispatchChangelogState(new ChangelogStateActions.SetQuery({ entity: { id: entityId } }, { partial: false, resetPagingIfModifying: true }));
    }, [entityId]);
    return (_jsxs(_Fragment, { children: [changelogState.edges?.map((edge) => {
                if (edge.node.isError())
                    return null;
                const event = edge.node.value;
                const entityInfo = 'entities' in event ? event.entities.find((it) => it.id === entity.id) : null;
                let shortType = event.type;
                if (shortType.endsWith('Entity'))
                    shortType = shortType.slice(0, -6);
                if (shortType.endsWith('Entities'))
                    shortType = shortType.slice(0, -8);
                shortType = shortType.replace('And', ' & ');
                return (_jsxs(Row, { gap: 2, children: [_jsx(Tag, { children: shortType }), _jsx(Tag, { children: entityInfo ? String(entityInfo.version) : '–' }), _jsx(Row.Item, { flexGrow: 1, children: _jsx(DateDisplay, { date: event.createdAt }) })] }, edge.cursor));
            }), _jsx(Row, { children: _jsx(ChangelogConnectionButtons, { changelogState, dispatchChangelogState }) })] }));
}
//# sourceMappingURL=EntityChangelogList.js.map